<script lang="ts" setup>
import type { ProductGroupCatalogSectionRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ data: ProductGroupCatalogSectionRecord }>();

const { locale } = useI18n();

const { data: productGroupData } = await useFetch("/api/cms/product-groups", {
  query: {
    locale: locale,
  },
});

const categories = await useCategories();

function getProductGroupLink(productGroupId: string) {
  const productGroup = productGroupData.value?.allProductGroups.find(pg => pg.id === productGroupId);
  if (!productGroup?.optCategory) {
    return null;
  }

  const categoryId = (productGroup.optCategory as Array<{ name: string; value: string }>).at(0)?.value;
  if (!categoryId) {
    return null;
  }

  const categoryPath = categories.tree.getPath(Number.parseInt(categoryId));
  if (!categoryPath) {
    return null;
  }

  return `/catalog${categoryPath}`;
}
</script>

<template>
  <div class="mb-3xl lg:mb-5xl flex justify-center">
    <div class="gap-md flex flex-col">
      <h4 class="text-center" v-html="data.title" />

      <div class="gap-md flex flex-wrap justify-center">
        <NuxtLinkLocale v-for="group in data.groups" :key="group.id" :to="getProductGroupLink(group.id) ?? undefined">
          <div
            class="p-sm gap-xs flex h-full w-[120px] flex-col items-center rounded-lg bg-white "
            :class="{ 'hover:bg-[#F3F1EC]': getProductGroupLink(group.id) }"
          >
            <img :src="group.icon.url" alt="" class="size-[64px]" loading="lazy">
            <div class="text-center text-[14px] font-bold">
              {{ group.name }}
            </div>
          </div>
        </NuxtLinkLocale>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
